var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('one-column-sidebar-left',[_c('div',{attrs:{"slot":"mainContent"},slot:"mainContent"},[_c('project-merge')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }